import React from "react";

import {
  Box,
  Container,
  Collapse,
  Text,
  HStack,
  Button,
  useDisclosure,
  VStack,
  Heading,
} from "@chakra-ui/react";
import IonIcon from "@reacticons/ionicons";
import "./styles.css";

const Faq = [
  {
    question: " What is the mint price? ",
    answer:
      "Mint price will be 0.04 ETH. This will be the cheapest price it goes for.",
  },
  {
    question: "When is mint?",
    answer: "Mint will begin in April 2022. Exact date TBA",
  },
  {
    question: "What is the total and available supply?",
    answer:
      "The total supply is 10,000 NFT. It will be available in 3 different drops.",
  },
  {
    question: "When will be the next supply drop?",
    answer:
      "Date of the next supply drop will be determined by the success and results of the first 1000 piece crowdfund sale.",
  },
  {
    question: "What is the max amount per wallet?",
    answer: " 10 NFTs per wallet. Our goal is to maximize the holder count.",
  },
  {
    question: "I got my NFT, what's next?",
    answer:
      "Get into our DIscord, meet the community and wait for the first tournament to begin!",
  },
  {
    question: "I wanna play. When will the game be released? ",
    answer:
      "We are hard at work already and will be posting sneak peaks soon. Approximate date of release: end of Q2, start of Q3 2022.",
  },
];

function index() {
  return (
    <Container maxW="container.xl" mb={32} w="100%" id="faq">
      <Box
        // margin="auto"
        w="100%"
        mb={5}
        padding={{ base: "10px", md: "15px", lg: "20px" }}
      >
        <VStack spacing={16}>
          <Heading as="h2" size="xl" textShadow="0px 0px 50px #FFFFFF">
            FAQs
          </Heading>
          <Text fontSize="xl">Frequently Asked Questions</Text>
          <VStack w="100%">
            {Faq.map((i, index) => (
              <Collapsible
                key={index}
                index={index}
                question={i.question}
                answer={i.answer}
              />
            ))}
          </VStack>
        </VStack>
      </Box>
    </Container>
  );
}

function Collapsible({ ...props }) {
  const { isOpen, onToggle, onClose, defaultIsOpen, id } = useDisclosure();

  const openCollapsible = () => {
    onToggle();
  };

  return (
    <Box
      borderBottom="1px solid #7A20AB"
      width={{ base: "100%", md: "100%" }}
      padding={{ base: "10px", md: "15px", lg: "20px" }}
      // cursor="pointer"
    >
      <Box
        onClick={openCollapsible}
        fontWeight="Bold"
        cursor="pointer"
        w="100%"
      >
        <HStack justify={{ base: "space-between" }} w="100%">
          <Text>0{props.index + 1}.</Text>
          <Text
            fontSize="md"
            textAlign={"center"}
            maxW={{ base: "200px", md: "100%" }}
          >
            {props.question}
          </Text>
          <Text minW={{ base: "10px", md: "20px" }} textAlign="right">
            <IonIcon
              name={isOpen ? "remove-outline" : "add-outline"}
              size="large"
            />
          </Text>

          {/* <IonIcon name="add-circle" size="large"></IonIcon>
          <IonIcon name="remove-circle" size="large"></IonIcon> */}
        </HStack>
      </Box>
      <Collapse in={isOpen} animateOpacity>
        <Box
          py="10px"
          px={{ base: "10px" }}
          mt=""
          // bg="teal.500"
          // rounded="md"
          // shadow="md"
        >
          <Text fontWeight="400" textAlign="center">
            {props.answer}
          </Text>
        </Box>
      </Collapse>
    </Box>
  );
}

export default index;
